"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var checkType_1 = require("./checkType");
var defaultValue_1 = require("./defaultValue");
/**
 * zwraca wyczyszczone dane, tylko te które są zgodne ze schematem
 *
 * @export
 * @param {JSONSchema} schema schemat
 * @param {*} data dane wejściowe
 * @param {boolean} [checkDataType] czy sprawdzac poprawnośc typów danych prostych
 * (number,integer,boolean, string), domyślnie nie
 * @param {IOptions} [options] opcje, zawierające np. informacje o wyłączonych polach
 * @param {string} [currentPath=''] bieżąca ścieżka
 * @returns {*} wyczyszczone dane
 */
function clearData(schema, data, checkDataType, options, currentPath) {
    if (currentPath === void 0) { currentPath = ''; }
    if (schema.computed) {
        return undefined;
    }
    if (schema.disabled) {
        if (schema.disabled === true || (options && options.disabledFields && options.disabledFields[currentPath])) {
            if (schema.type === 'array') {
                if (schema.default) {
                    return Array.from(schema.default);
                }
                else {
                    return undefined;
                }
            }
            else {
                return defaultValue_1.default(schema, false);
            }
        }
    }
    if (schema.type === 'object') {
        if (typeof data !== 'object') {
            return undefined;
        }
        if (data === null) {
            return null;
        }
        var result = {};
        var props = schema.properties;
        if (props) {
            var path = currentPath === '' ? currentPath : currentPath + '.';
            for (var key in props) {
                if (props.hasOwnProperty(key)) {
                    var value = data[key];
                    var element = props[key];
                    if (value !== undefined) {
                        var nvalue = clearData(element, value, checkDataType, options, path + key);
                        if (nvalue !== undefined) {
                            result[key] = nvalue;
                        }
                    }
                }
            }
        }
        return result;
    }
    else if (schema.type === 'array') {
        if (Array.isArray(data)) {
            var result = [];
            var items = schema.items;
            // tslint:disable-next-line: prefer-for-of
            for (var i = 0; i < data.length; i++) {
                var nvalue = clearData(items, data[i], checkDataType, options, currentPath + '[' + i + ']');
                if (nvalue !== undefined) {
                    result.push(nvalue);
                }
            }
            return result;
        }
        else {
            return undefined;
        }
    }
    else {
        // na razie nie sprawdzamy typów danych
        if (Array.isArray(data)) {
            return undefined;
        }
        if (typeof data === 'object') {
            return undefined;
        }
        if (checkDataType && !checkType_1.default(schema, data)) {
            return undefined;
        }
        return data;
    }
}
exports.default = clearData;
//# sourceMappingURL=clearData.js.map